import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
/* src/app/page.login/view.scss: no such file or directory */`],
})
export class PageLoginComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public returnTo: string = "notset";
    @Input() title: any;
    public showSignup: boolean = false;
    public loaded = false;

    public user = {
        email: '',
        password: ''
    }

    public signupData = {
        name: '',
        email: '',
        password: '',
        password_repeat: ''
    }

    public async ngOnInit() {
        await this.service.init();
        let returnTo = this.getParam('returnTo', '/dashboard');
        let check = await this.service.auth.allow(false, returnTo);
        if (check)
            this.returnTo = returnTo;
        this.loaded = true;
        await this.service.render();
    }


    public getParam(sname, defaultvalue) {
        let params = location.search.substring(location.search.indexOf("?") + 1);
        let sval = defaultvalue;
        params = params.split("&");
        for (let i = 0; i < params.length; i++) {
            let temp = params[i].split("=");
            if ([temp[0]] == sname) { sval = temp[1]; }
        }
        return decodeURIComponent(sval);
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }
    public async show() {
        this.showSignup = !this.showSignup;
        await this.service.render();
    }
    public async login(event: Event) {
        event.preventDefault();

        let user = JSON.parse(JSON.stringify(this.user));
        if (user.password)
            user.password = this.service.auth.hash(user.password);
        else
            delete user.password;

        let { code, data } = await wiz.call("login", user);
        if (code == 200) {
            if (data == 'dormant') {
                this.view = "login.terms"
                await this.service.render();
            } else {
                location.href = "/dashboard";
            }
        } else if (code == 201) {
            this.view = "login.password";
            await this.service.render();
            try {
                setTimeout(() => {
                    document.querySelector("input[type=password]").focus();
                }, 150);
            } catch (err) {
            }
        } else if (code == 301) {
            let isjoin = await this.alert(data, 'success', '닫기', '계정 만들기');
            if (!isjoin) return;
            this.view = "join.terms";
            await this.service.render();
        } else {
            await this.alert(data, 'error');
        }
    }


    public async signup(event: Event) {
        event.preventDefault();
        if (!this.service.alert || !this.service.alert.show) {
            console.error("alert service가 초기화되지 않았습니다.");
            return;
        }
        if (this.signupData.name.length == 0) return await this.alert("이름을 입력해주세요");
        let password = this.signupData.password;
        let password_re = this.signupData.password_repeat;
        if (password.length < 8) return await this.alert("8글자 이상의 비밀번호를 설정해주세요");
        if (password.search(/[a-z]/i) < 0) return await this.alert("비밀번호에 알파벳을 포함해주세요");
        if (password.search(/[0-9]/) < 0) return await this.alert("비밀번호에 숫자를 포함해주세요");
        if (password != password_re) return await this.alert("비밀번호가 일치하지 않습니다");
        let user = JSON.parse(JSON.stringify(this.signupData));


        delete user.password_repeat;

        user.password = this.service.auth.hash(user.password);

        let { code } = await wiz.call("join", user);

        if (code == 200) {
            await this.alert("회원가입이 완료되었습니다. 관리자 승인 후 로그인 가능합니다.", "success");
            location.reload();
        } else {
            await this.alert(data);
        }
    }


}

export default PageLoginComponent;